import styled from 'styled-components';

export const Container = styled.div`
padding: 10px;
`;

export const TextContainer = styled.div`
  max-width: 800px;
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow-y: auto;
  background-color: white;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  white-space: normal;
  word-break: break-word;
`;
